storefrontApp.service('notificationModalService', ['$http', function ($http) {
    return {
        getNotificationModal: function (type) {
            var notificationModal = {
                show: true,
                imagePath: null,
                header: null,
                message: null,
                showButton: true
            }
            if (type == 'PROFILE') {
                notificationModal.imagePath = '/images/success-gifs/sign-up.gif';
                notificationModal.header = 'One and Only';
                notificationModal.message = 'Your profile has been updated.';
            }
            else if (type == 'AUTORENEW') {
                notificationModal.imagePath = '/images/success-gifs/sign-up.gif';
                notificationModal.header = 'Auto-Renewal Activated';
                notificationModal.message = 'Your membership will now automatically renew before expiration to ensure uninterrupted access.';
            }
            else if (type == "DELETEADDRESS") {
                notificationModal.imagePath = '/images/success-gifs/sign-up.gif';
                notificationModal.header = 'Address Deleted';
                notificationModal.message = 'Your address has been deleted.';
            }
            else if (type == 'ADDADDRESS') {
                notificationModal.imagePath = '/images/success-gifs/sign-up.gif';
                notificationModal.header = 'Address Added';
                notificationModal.message = 'Your address has been added.';
            }
            else if (type == "UPDATEADDRESS") {
                notificationModal.imagePath = '/images/success-gifs/sign-up.gif';
                notificationModal.header = 'EDITS SAVED!';
                notificationModal.message = 'Your profile has been updated.';
            }
            else if (type == "CHANGEPASSWORD") {
                notificationModal.imagePath = '/images/success-gifs/Change-Password.gif';
                notificationModal.header = 'CHANGE PASSWORD';
                notificationModal.message = 'Your password has successfully been changed!';
            }
            else if (type == "UPDATESUBSCRIPTIONS") {
                notificationModal.imagePath = '/images/success-gifs/Edit-Subscriptions.gif';
                notificationModal.header = 'CRAFTY OF COURSE!';
                notificationModal.message = 'Your subscriptions have been updated.';
            }
            else if (type == "ADDCARD") {
                notificationModal.imagePath = '/images/success-gifs/Payment-Method.gif';
                notificationModal.header = 'Card Added';
                notificationModal.message = 'Your credit card has been added.';
            }
            else if (type == "UPDATECARD") {
                notificationModal.imagePath = '/images/success-gifs/Payment-Method.gif';
                notificationModal.header = 'PAYMENT READY!';
                notificationModal.message = 'Your payment method has been updated.';
            }
            else if (type == "DELETECARD") {
                notificationModal.imagePath = '/images/success-gifs/Payment-Method.gif';
                notificationModal.header = 'Card Deleted';
                notificationModal.message = 'Your credit card has been deleted.';
            }
            else if (type == "MESSAGESENT") {
                notificationModal.imagePath = '/images/success-gifs/Contact-Us.gif';
                notificationModal.header = 'MESSAGE SENT!';
                notificationModal.message = 'Thank you! We\'ll review your message and get back to you.';
            }
            else if (type == "DOWNLOAD") {
                notificationModal.imagePath = '/images/success-gifs/Downloading.gif';
                notificationModal.header = 'START CRAFTING!';
                notificationModal.message = 'Your download had begun.';
            }
            else if (type == "REVIEW") {
                notificationModal.imagePath = '/images/success-gifs/Create-Review.gif';
                notificationModal.header = 'CRAFTLY WRITTEN!';
                notificationModal.message = 'Your review has been created.';
                notificationModal.redirectPage = true;
            }
            else if (type == "PAYMENTPROCESSING") {
                notificationModal.imagePath = '/images/success-gifs/ATG-Checkout-Loading.gif';
                notificationModal.header = 'PAYMENT PROCESSING';
                notificationModal.message = 'Almost there! Your order may take a few minutes to process.';
            }
            else if (type == "PAYMENTSUCCESS") {
                notificationModal.imagePath = '/images/success-gifs/Checkout.gif';
                notificationModal.header = 'SUCCESS!';
                notificationModal.message = 'Thank you! Your payment has been processed. Your receipt will be available on the next screen.';
            }
            else if (type == "PAYMENTERROR") {
                notificationModal.imagePath = '/images/success-gifs/Checkout-Error.gif';
                notificationModal.header = 'TRANSACTION ERROR';
                notificationModal.message = 'This transaction cannot be processed. Please enter a valid credit card expiration month.';
                notificationModal.redirectPage = true;
            }
            else if (type == "ADDTOCART") {
                notificationModal.imagePath = '/images/success-gifs/Added-to-Cart.gif';
                notificationModal.header = 'EMBROIDER AWAY!';
                notificationModal.message = 'Thank you! This item has been added to your cart.';
            }
            else if (type == "FAVORITEITEM") {
                notificationModal.imagePath = '/images/success-gifs/Favorites-List.gif';
                notificationModal.header = 'LOVE STRUCK!';
                notificationModal.message = 'Your design has been added to your favorites.';
            }
            else if (type == "FAVORITEBRAND") {
                notificationModal.imagePath = '/images/success-gifs/Favorite-Brands.gif';
                notificationModal.header = 'FOREVER LOVE!';
                notificationModal.message = 'You will now receive notifications when new designs are added from this brand.';
            }
            else if (type == 'REDEEMGIFTCARD') {
                notificationModal.imagePath = '/images/atg-sm.png';
                notificationModal.header = 'Your All Set!';
                notificationModal.message = 'Your Gift Card has been added.';
            }
            else if (type == 'REDEEMERROR') {
                notificationModal.imagePath = '/images/atg-sm.png';
                notificationModal.header = 'Gift Card Cannot be Redeemed';
                notificationModal.message = 'Please contact our support.';
                notificationModal.redirectPage = true;
            }
            else if (type == "ADDMACHINE") {
                notificationModal.imagePath = '/images/atg-sm.png';
                notificationModal.header = 'Machine Added';
                notificationModal.message = 'Your machine has been added.';
            }
            else if (type == "UPDATEMACHINE") {
                notificationModal.imagePath = '/images/atg-sm.png';
                notificationModal.header = 'Machine Updated';
                notificationModal.message = 'Your machine has been updated.';
            }
            else if (type == "DELETEMACHINE") {
                notificationModal.imagePath = '/images/atg-sm.png';
                notificationModal.header = 'Machine Deleted';
                notificationModal.message = 'Your machine has been deleted.';
            }
            else if (type == "ERROR") {
                notificationModal.imagePath = '/images/atg-sm.png';
                notificationModal.header = 'Error';
                notificationModal.message = 'Something went wrong with processing your request. Please contact support.';
                notificationModal.redirectPage = true;
            }  
            else if (type == "ORDERERROR") {
                notificationModal.imagePath = "/images/success-gifs/Checkout-Error.gif";
                notificationModal.header = "Something Went Wrong!";
                notificationModal.message = "Please contact our support.";
                notificationModal.redirectPage = true;
            }
            else if (type == "FRAUDORDERERROR") {
                notificationModal.imagePath = "/images/success-gifs/Checkout-Error.gif";
                notificationModal.header = "Suspected Fraud Activity";
                notificationModal.message = "This transaction cannot be processed due to suspected fraud activity. Contact Support for help.";
            }   
            else if (type == "ORDERSUCCESS") {
                notificationModal.imagePath = "/images/success-gifs/Checkout.gif";
                notificationModal.header = "Success!";
                notificationModal.message = "Thank you! Your payment has been processed.";
                notificationModal.showButton = false;
            } 
            else if (type == "ORDERPROCEEDING") {
                notificationModal.imagePath = "/images/success-gifs/Checkout.gif";
                notificationModal.header = "Please Wait...";
                notificationModal.message = "Your order is being processed. Do not click the back or refresh button.";
                notificationModal.showButton = false;
            }
            else if (type == "EMAILCAMPAIGN") {
                notificationModal.imagePath = "/images/success-gifs/sign-up.gif";
                notificationModal.header = "Thank you! for signing up for specials";
                notificationModal.message = "Please add sales@annthegran.com to your address book.";
            }
            else if (type == "EMAILVERIFICATIONSUCCESS") {
                notificationModal.imagePath = "/images/success-gifs/Change-Password.gif";
                notificationModal.header = "Success!";
                notificationModal.message = "Your Email Address has been successfully verified.";
            }
            else if (type == "RESENDEMAILLINKSUCCESS") {
                notificationModal.imagePath = "/images/success-gifs/Checkout.gif";
                notificationModal.header = "Verification Email Sent!";
                notificationModal.message = "Account verification email has been resent to your email address.";
            } 
            else if (type == "RESENDEMAILLINKERROR") {
                notificationModal.imagePath = "/images/success-gifs/Checkout-Error.gif";
                notificationModal.header = "Error";
                notificationModal.message = "Something went wrong. Please contact our Support.";
            }   
            return notificationModal;
        }
    }
}]);
